import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Public Components
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhoWeAre from './components/WhoWeAre';
import Testimonials from './components/Testimonials';
import Features from './components/Features';
import Solutions from './components/Solutions';
import Services from './components/Services';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import ConsultationModal from './components/ConsultationModal';
import Footer from './components/Footer';

// Admin Components
import AdminLayout from './admin/AdminLayout';
import LoginPage from './admin/LoginPage';
import RegisterPage from './admin/RegisterPage';
import DashboardPage from './admin/DashboardPage';
import AdminPages from './admin/AdminPages';
import AdminServices from './admin/AdminServices';
import AdminPackages from './admin/AdminPackages';
import AdminUsers from './admin/AdminUsers';
import AdminForms from './admin/AdminForms';
import AdminFormSubmissions from './admin/AdminFormSubmissions';
import AdminTestimonials from './admin/AdminTestimonials';
import AdminBlogs from './admin/AdminBlogs';
import AdminContacts from './admin/AdminContacts';
// import AdminEvents from './admin/AdminEvents';

// User Pages
import UserLoginPage from './pages/UserLoginPage';
import UserLayout from './user/UserLayout';
import UserDashboardPage from './user/UserDashboardPage';
import DynamicPage from './pages/DynamicPage';
import AboutPage from './pages/AboutPage';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import ContactPage from './pages/ContactPage';
import ThankYouPage from './pages/ThankYouPage';

const PublicLayout = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);
  const [initialService, setInitialService] = useState('');

  const openConsultation = (serviceName = '') => {
    setInitialService(serviceName);
    setIsConsultationOpen(true);
  };

  return (
    <div className="App">
      <TopBar />
      <Navbar />
      <Hero onOpenConsultation={openConsultation} />
      <WhoWeAre />
      <Services onOpenConsultation={openConsultation} />
      <Testimonials />
      <Features />
      <Solutions />
      <FAQ />
      <FinalCTA onOpenConsultation={openConsultation} />
      <Footer />
      <ConsultationModal 
        isOpen={isConsultationOpen} 
        onClose={() => setIsConsultationOpen(false)} 
        initialService={initialService}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<PublicLayout />} />

        {/* About Us Page */}
        <Route path="/about" element={<AboutPage />} />

        {/* Blogs Pages */}
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />

        {/* Contact Page */}
        <Route path="/contact" element={<ContactPage />} />

        {/* Thank You Page */}
        <Route path="/thank-you" element={<ThankYouPage />} />

        {/* Dynamic Public Pages Route */}
        <Route path="/pages/:slug" element={<DynamicPage />} />

        {/* User Login — role-based redirect */}
        <Route path="/login" element={<UserLoginPage />} />

        {/* User Registration */}
        <Route path="/register" element={<RegisterPage />} />

        {/* User Dashboard Routes (With Sidebar) */}
        <Route path="/user/*" element={<UserLayout />}>
          <Route path="dashboard" element={<UserDashboardPage />} />
        </Route>

        {/* Admin Login Route (admin-only, No Sidebar) */}
        <Route path="/admin_login" element={<LoginPage />} />

        {/* Admin Dashboard Routes (With Sidebar) */}
        <Route path="/admin/*" element={<AdminLayout />}>
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="pages" element={<AdminPages />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="packages" element={<AdminPackages />} />
          <Route path="forms" element={<AdminForms />} />
          <Route path="forms/:id/submissions" element={<AdminFormSubmissions />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
          <Route path="blogs" element={<AdminBlogs />} />
          <Route path="contacts" element={<AdminContacts />} />
          {/* <Route path="events" element={<AdminEvents />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
